/* istanbul ignore file */

export const TASK_CLASSIFICATION_ID = 'task-classification';
export const FRAME_CLASSIFICATION_ID = 'frame-classification';
export const FILTER_OPTIONS: {
  id: string;
  label: string;
}[] = [{
  id: 'all',
  label: 'All'
}, {
  id: 'approved',
  label: 'Approved'
}, {
  id: 'rejected',
  label: 'Rejected'
}];
export const REVIEW_ANNOTATION_TYPE = ({
  ANNOTATION: 'annotation',
  CLASSIFICATION: 'classification'
} as const);
export const REVIEW_ANNOTATION_STATUS = ({
  APPROVED: 'approved',
  REJECTED: 'rejected'
} as const);
export const REVIEW_MODE_PANEL_TABS = ({
  PENDING: 'pending',
  COMPLETED: 'completed'
} as const);
export const REVIEW_COMMENT_LEVEL = ({
  TASK: 'task',
  ANNOTATION: 'annotation'
} as const);

/** Mirrors domains labeling.proto CommentSource for review / feedback UI. */
export const REVIEW_COMMENT_SOURCE = ({
  HUMAN: 'human',
  BOT: 'bot'
} as const);
export const REVIEW_FEATURES = ({
  ACCEPT_REJECT_TASK: 'acceptRejectTask',
  ACCEPT_REJECT_LABEL: 'acceptRejectLabel',
  ENABLE_COMMENTS_FEEDBACK: 'enableCommentsFeedback',
  ENABLE_MISSING_LABELS_FEEDBACK: 'enableMissingLabelsFeedback',
  CAN_EDIT: 'canEdit',
  ENABLE_CONTINUOUS_PLAYBACK: 'enableContinuousPlayback',
  ENABLE_BATCH_MODE: 'enableBatchMode'
} as const);